'use es6';

import { REQUESTED_SMART_CONTENT, REQUESTED_SMART_CONTENT_FAILED, REQUESTED_SMART_CONTENT_SUCCEEDED } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
import SmartContent from '../models/SmartContent';
export default ((state = new SmartContent(), {
  type,
  payload
}) => {
  switch (type) {
    case REQUESTED_SMART_CONTENT:
      return state.set('status', RequestStatus.PENDING);
    case REQUESTED_SMART_CONTENT_FAILED:
      return state.set('status', RequestStatus.FAILED);
    case REQUESTED_SMART_CONTENT_SUCCEEDED:
      return payload.smartContent;
    default:
      return state;
  }
});